import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ArrowRight = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9678 8C14.974 8 15.8837 8.89878 16.9895 9.99728C18.0953 11.0958 19 11.997 19 12C19 12.0108 14.9787 16 14.9679 16C14.9618 16 14.7589 15.8033 14.5169 15.5628L14.0769 15.1256L15.6556 13.5574L16.5522 12.6667L6.52137 12.6667V11.3333L16.5742 11.3333L15.6612 10.4264L14.0882 8.8637L14.5224 8.43185C14.7612 8.19433 14.9616 8 14.9678 8Z"
        />
    </StarryUIIcon>
);
